import ServiceApi from "../ServiceApi";
class SystemServiceApi extends ServiceApi {
  constructor() {
    super("systemService", "system");
  }
  /**
   * Get server date in timestamp
   *
   */
  getServerTime() {
    return this.request("getTime");
  }
}
export default new SystemServiceApi();
